"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QUESTION_WITH_LEARNING_FIELDS = exports.QUESTION_WITH_COMMENT_FIELDS = exports.QUESTION_WITH_HIGHLIGHT_FIELDS = exports.QUESTION_FIELDS = exports.QUESTION_CATEGORY_FIELDS = exports.QUESTION_UCAT_FIELDS = exports.QUESTION_UKMLA_FIELDS = exports.QUESTION_COMMENT_FIELDS = void 0;
const client_1 = require("@apollo/client");
const chapter_1 = require("./chapter");
const concept_1 = require("./concept");
const highlight_1 = require("./highlight");
const picture_1 = require("./picture");
exports.QUESTION_COMMENT_FIELDS = (0, client_1.gql) `
  fragment QuestionCommentFields on QuestionComment {
    id
    createdAt
    comment
    parentId
    likes
    user {
      id
      displayName
      accessLevel
    }
    dislikes
    isLikedByMe
    questionId
    replies {
      id
      createdAt
      comment
      parentId
      user {
        id
        displayName
        accessLevel
      }
      likes
      dislikes
      isLikedByMe
      questionId
    }
  }
`;
exports.QUESTION_UKMLA_FIELDS = (0, client_1.gql) `
  fragment QuestionUkmlaFields on Question {
    presentations {
      id
      name
      topicId
      topic {
        id
        name
      }
    }
    conditions {
      id
      name
      topicId
      topic {
        id
        name
      }
    }
  }
`;
exports.QUESTION_UCAT_FIELDS = (0, client_1.gql) `
  ${chapter_1.CHAPTER_FIELDS}
  fragment QuestionUcatFields on Question {
    themes {
      id
      name
      entitlementId
      entitlement {
        id
        name
      }
    }
    timeTaken
    avgTimeTaken
    stem {
      ...ChapterFields
    }
  }
`;
exports.QUESTION_CATEGORY_FIELDS = (0, client_1.gql) `
  fragment QuestionCategoryFields on Question {
    ... on QuestionSBA {
      sbaAnswer: answer
    }
    ... on QuestionQA {
      qaAnswer: answer {
        dose
        units
      }
    }
    ... on QuestionEMQ {
      cases {
        id
        questionId
        case
        explanation
        label
      }
      emqAnswer: answer
    }
    ... on QuestionMultiA {
      multiAnswer: answer
    }
    ... on QuestionRanking {
      rankingAnswer: answer
    }
    ... on QuestionSelect3 {
      select3Answer: answer
    }
    ... on QuestionPrescription {
      prescribeAnswer: answer {
        dose {
          value
          label
          visible
        }
        drug {
          value
          label
          visible
        }
        route {
          value
          label
          visible
        }
        frequency {
          value
          label
          visible
        }
        duration {
          value
          label
          visible
        }
      }
    }
  }
`;
exports.QUESTION_FIELDS = (0, client_1.gql) `
  ${exports.QUESTION_UCAT_FIELDS}
  ${exports.QUESTION_UKMLA_FIELDS}
  ${highlight_1.HIGHLIGHT_FIELDS}
  ${exports.QUESTION_CATEGORY_FIELDS}
  ${exports.QUESTION_COMMENT_FIELDS}
  ${concept_1.CONCEPT_FIELDS}
  ${picture_1.PICTURE_FIELDS}
  fragment QuestionFields on Question {
    id
    conceptId
    difficulty
    dislikes
    explanation
    learningPoint
    isLikedByMe
    userPoint
    likes
    question
    totalVotes
    typeId
    psaSectionId
    highlights {
      ...HighlightFields
    }
    choices {
      id
      explanation
      name
      label
      answer
      votes
      picture {
        ...PictureFields
      }
    }
    comments {
      ...QuestionCommentFields
    }
    concept {
      # needed for daily stack
      totalCards
      ...ConceptFields
    }
    pictures {
      ...PictureFields
    }
    ...QuestionUkmlaFields
    ...QuestionCategoryFields
    ...QuestionUcatFields
  }
`;
// used in cache updator
exports.QUESTION_WITH_HIGHLIGHT_FIELDS = (0, client_1.gql) `
  fragment QuestionWithHighlightFields on Question {
    highlights {
      start
      end
      text
      part
      tag
      color
    }
  }
`;
// used in cache updator
exports.QUESTION_WITH_COMMENT_FIELDS = (0, client_1.gql) `
  ${exports.QUESTION_COMMENT_FIELDS}
  fragment QuestionWithCommentFields on Question {
    id
    likes
    dislikes
    isLikedByMe
    comments {
      ...QuestionCommentFields
    }
  }
`;
// used in cache updator
exports.QUESTION_WITH_LEARNING_FIELDS = (0, client_1.gql) `
  fragment QuestionWithLearningFields on Question {
    userPoint
  }
`;
